import React, { PureComponent } from 'react'
import ShoutItem from './ShoutItem'
import EventItem from './EventItem'
import ItemItem from './ItemItem'
import ExperienceItem from './ExperienceItem'
import BusinessItem from './BusinessItem'
import UserItem from './UserItem'
import SectionItem from './SectionItem'
import AlbumItem from './AlbumItem'

export default class FlagItem extends PureComponent {
  render() {
    switch (this.props.type) {
      case 'shout':
        return <ShoutItem gnObject={this.props.gnObject} {...this.props} />
      case 'event':
        return <EventItem gnObject={this.props.gnObject} {...this.props} />
      case 'item':
        return <ItemItem gnObject={this.props.gnObject} {...this.props} />
      case 'experience':
        return <ExperienceItem gnObject={this.props.gnObject} {...this.props} />
      case 'business':
        return <BusinessItem gnObject={this.props.gnObject} {...this.props} />
      case 'user':
        return <UserItem gnObject={this.props.gnObject.user} {...this.props} />
      case 'section':
        return <SectionItem gnObject={this.props.gnObject} {...this.props} />
      case 'album':
        return <AlbumItem gnObject={this.props.gnObject} {...this.props} />
      default:
        console.log(this.props)
        return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Components/FlagItem.js